import { selectBlocksByNode } from '@octopus-do/octopus-project-core'
import { thunkAddBlock } from '@store/migrationActions/thunkActions/thunkBlocksActions'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import type React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import { THEME_BOLD } from '@/constants/constants'
import { clsJoin } from '@/utils'
import { VARIANTS } from '../Node/constants'
import css from '../Node/Node.module.scss'
import BlocksList from './BlocksList'

type BlocksType = {
  nodeId: string
}

const Blocks: React.FC<BlocksType> = ({ nodeId }) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  const node = useSelector(migrationProjectSelector.getProjectNodeById(nodeId))

  const ids = useSelector(selectBlocksByNode(nodeId), shallowEqual)

  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  const theme = useSelector(migrationProjectSelector.getProjectTheme)

  const themeBold = theme === THEME_BOLD

  const onClick = () => {
    if (isReadOnly) {
      return
    }

    const blockId = dispatch(thunkAddBlock(nodeId, node.colorId))

    dispatch({
      type: CanvasActionTypes.SELECT_TO_EDIT_BLOCK,
      payload: {
        nodeId,
        blockId,
        isAutoCreated: true,
      },
    })
  }

  if (!node) {
    return null
  }

  return (
    <div className={css.blocks}>
      {!isReadOnly &&
        (!ids || ids.length === 0 || node.variant === VARIANTS.GHOST) && (
          <div className={clsJoin(css.addBlock, themeBold && css.addBlockBold)}>
            <div className={css.addBlockInner} onClick={onClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="8"
                viewBox="0 0 8 8"
              >
                <g fill="var(--node-color)">
                  <path d="M0 3H8V5H0z" />
                  <path d="M3 0H5V8H3z" />
                </g>
              </svg>
            </div>
          </div>
        )}

      {ids && ids.length && node.variant !== VARIANTS.GHOST && (
        <BlocksList nodeId={nodeId} ids={ids} />
      )}
    </div>
  )
}

export default Blocks
